import React, {Component, Fragment} from 'react';
import {
  Card,
  CardBody,
  Row,
  Col,
  Form,
  CardTitle, Input,
} from 'reactstrap';
import {Field, Form as FinalForm} from 'react-final-form';
import {withTranslation} from 'react-i18next';
import TextField from '../../../components/TextField';
import {Colxx, Separator} from '../../../components/common/CustomBootstrap';
import {NotificationManager} from "../../../components/common/react-notifications";
import {getDatePickerProps, numberWithCommas, stringToNumber} from "../../../helpers/Utils";
import {
  composeValidators,
  mustBeInteger,
  mustBeNumber,
  mustBePositive,
  mustNotBeNegative,
  required
} from "../../../helpers/Validators";
import {DateTimePicker, MuiPickersUtilsProvider} from "@material-ui/pickers";
import ModalManager from "../../../components/modal/ModalManager";
import LoaderButton from '../../../components/LoaderButton';
import Breadcrumb from '../../../containers/navs/Breadcrumb';
import FieldError from "../../../components/FieldError";
import {camelCase, find, upperFirst} from "lodash";
import fa_IR from "../../../constants/locales";
import {store} from "../../../AppRenderer";
import JalaliUtils from "@date-io/jalaali";
import MomentUtils from "@date-io/moment";
import i18n from "../../../services/i18n";
import Api from "../../../services/Api";
import Select from "react-select";
import moment from "moment";
import Switch from "react-switch";

class Create extends Component {
  constructor(props) {
    super(props);
    this.state = {
      destInputValue: '',
    };
    this.pairOptions = store.getState().general.pairs.map(pair => ({
      label: pair.name, value: pair.name,
    }));
    this.typeOptions = [
      {label: "REFERRAL", value: "REFERRAL"},
      {label: "MAX_REFERRAL", value: "MAX_REFERRAL"},
      {label: "TRADE_FEE", value: "TRADE_FEE"},
    ];
    this.feeOptions = [
      {label: "PERCENTAGE", value: "PERCENTAGE"},
      {label: "NEW_AMOUNT", value: "NEW_AMOUNT"},
    ];
    this.expirationConditions = [
      {label: "TRADE_VOLUME", value: "TOTAL_VOL"},
      {label: "INTERVAL", value: "USAGE_TIME"},
      {label: "TIMESTAMP", value: "END_TIME"},
    ];
    this.validityConditions = [
      {label: "NUMBER_OF_USAGES", value: "NUMBER_OF_USAGES"},
      {label: "TIMESTAMP", value: "TIMESTAMP"},
    ];
  }

  createBonusCard = async values => {
    const {t} = this.props;
    const {
      code,
      name,
      recipientType,
      recipient,
      assignType,
      effectObject,
      feePolicyType,
      referralPolicyType,
      pairs,
      percent,
      limit,
      amount,
      expirationConditions,
      volume,
      interval,
      expiresAt,
      validityConditions,
      validatedUntil,
      extendToCurrent,
      count
    } = values;
    const effectFuncName = effectObject.value === "TRADE_FEE" ? feePolicyType.value : referralPolicyType.value;
    const reqValues = {
      code,
      name,
      status: "STARTED",
      effectObject: effectObject.value,
      assignType: assignType.value,
      recipient: {type: recipientType.value, value: recipientType.value === "GROUP" ? recipient.value : recipient},
      effectFunction: {
        name: upperFirst(camelCase(effectFuncName)),
        params: {
          ...(effectFuncName === "PERCENTAGE" ? {percent} : null),
          ...(effectFuncName === "NEW_LIMIT" ? {limit} : null),
          ...(effectFuncName === "NEW_MAX_LIMIT" ? {limit, extendToCurrent: !!extendToCurrent} : null),
          ...(effectFuncName === "NEW_AMOUNT" ? {amount} : null),
          ...(effectObject.value === "TRADE_FEE" && pairs && pairs.length > 0 ? {
            pairs: pairs.map(item => item.value),
          } : null),
        },
      },
      ...(validityConditions && validityConditions.length > 0 ? {
          endValidityCriteria: {
            ...(validityConditions && !!find(validityConditions, {value: 'TIMESTAMP'}) ?
              {time: moment(validatedUntil).toISOString()} : null),
            ...(validityConditions && !!find(validityConditions, {value: 'NUMBER_OF_USAGES'}) ?
              {numUsage: Number(count)} : null),
          },
        } : null
      ),
      ...(expirationConditions && expirationConditions.length > 0 ? {
        expireFunctions: expirationConditions.map(item => ({
          name: upperFirst(camelCase(item.value)),
          params: {
            ...(item.value === "END_TIME" ? {time: moment(expiresAt).toISOString()} : null),
            ...(item.value === "USAGE_TIME" ? {interval: Number(interval)} : null),
            ...(item.value === "TOTAL_VOL" ? {vol: volume} : null),
          }
        })),
      } : null),
    };
    try {
      await Api.invoke('POST', '/v2/admin-ui/bonusPolicies', reqValues);
      NotificationManager.success(t('Bonus card created successfully'), t('Message'));
    } catch (e) {
      if (e.fieldError) {
        return e.fieldError;
      }
      throw e;
    }
  };

  SelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      placeholder={this.props.t('Select')}
    />
  );

  MultiSelectAdapter = ({input, ...rest}) => (
    <Select
      {...input}
      {...rest}
      isMulti
      placeholder={this.props.t('Select')}
      closeMenuOnSelect={false}
    />
  );

  openConfirmDialog = onConfirm => {
    const {t} = this.props;
    ModalManager.open({
      isOpen: true,
      title: t('Submit Confirm'),
      body: t('Are you sure you want to create this bonus card ?'),
      buttons: [
        {
          color: 'primary',
          onClick: async () => {
            onConfirm();
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('Yes'),
        },
        {
          color: 'light',
          onClick: () => {
            ModalManager.close({
              isOpen: false
            });
          },
          text: t('No'),
        },
      ],
    });
  };

  render() {
    const {t, match} = this.props;
    return (
      <Fragment>
        <Row>
          <Colxx xxs="12">
            <Breadcrumb match={match}/>
            <Separator className="mb-5"/>
          </Colxx>
        </Row>
        <Row>
          <Colxx xxs="12" className="mb-4">
            <Card className="h-100">
              <CardBody>
                <CardTitle className="text-large text-primary">
                  {t('Create Bonus Card')}
                </CardTitle>
                <FinalForm
                  onSubmit={this.createBonusCard}
                  render={({handleSubmit, submitting, pristine, hasValidationErrors, values}) => {
                    return (
                      <Form onSubmit={handleSubmit}>
                        <Row className="mb-2">
                          <Col className="col-lg-5 col-md-12">
                            <TextField
                              item={{
                                name: 'name',
                                i18n: t('Name'),
                                type: 'text',
                                required: true,
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-2">
                          <Col className="col-lg-5 col-md-12">
                            <TextField
                              item={{
                                name: 'code',
                                i18n: t('Code'),
                                type: 'text',
                              }}
                            />
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Assign Type')}<span className="required">*</span></span>
                            <Field
                              name="assignType"
                              options={[
                                {label: t('Assign automatically'), value: 'AUTO'},
                                {label: t('Assign by activating the code'), value: 'MANUAL'},
                              ]}
                              component={this.SelectAdapter}
                              validate={required}
                            />
                            <FieldError name='assignType'/>
                          </Col>
                        </Row>
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Recipient Type')}<span className="required">*</span></span>
                            <Field
                              name="recipientType"
                              options={[
                                {label: 'GROUP', value: 'GROUP'},
                                {label: 'USER', value: 'USER'},
                              ]}
                              component={this.SelectAdapter}
                              validate={required}
                            />
                            <FieldError name='recipientType'/>
                          </Col>
                        </Row>
                        {!!values.recipientType && values.recipientType.value === "GROUP" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('User Groups')}<span className="required">*</span></span>
                              <Field
                                name="recipient"
                                options={[
                                  {label: 'ALL_USERS', value: ''},
                                ]}
                                component={this.SelectAdapter}
                                validate={required}
                              />
                              <FieldError name='recipientType'/>
                            </Col>
                          </Row>
                        }
                        {!!values.recipientType && values.recipientType.value === "USER" &&
                          <Row className="mb-2">
                            <Col className="col-lg-5 col-md-12">
                              <TextField
                                item={{
                                  name: 'recipient',
                                  i18n: t('User Id'),
                                  type: 'text',
                                  required: true,
                                }}
                              />
                            </Col>
                          </Row>
                        }
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Bonus Type')}<span className="required">*</span></span>
                            <Field
                              name="effectObject"
                              component={this.SelectAdapter}
                              options={this.typeOptions}
                              validate={required}
                            />
                            <FieldError name='effectObject'/>
                          </Col>
                        </Row>
                        {!!values.effectObject && values.effectObject.value === 'TRADE_FEE' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Fee policy')}<span className="required">*</span></span>
                              <Field
                                name="feePolicyType"
                                component={this.SelectAdapter}
                                options={this.feeOptions}
                                validate={required}
                              />
                              <FieldError name='feePolicyType'/>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'REFERRAL' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Referral policy')}</span>
                              <Field
                                name="referralPolicyType"
                                component={this.SelectAdapter}
                                initialValue={{label: "NEW_LIMIT", value: "NEW_LIMIT"}}
                                isDisabled={true}
                              />
                              <FieldError name='referralPolicyType'/>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'MAX_REFERRAL' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Referral policy')}</span>
                              <Field
                                name="referralPolicyType"
                                component={this.SelectAdapter}
                                initialValue={{label: "NEW_MAX_LIMIT", value: "NEW_MAX_LIMIT"}}
                                isDisabled={true}
                              />
                              <FieldError name='referralPolicyType'/>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'TRADE_FEE' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Pairs')}</span>
                              <Field
                                name="pairs"
                                component={this.MultiSelectAdapter}
                                options={this.pairOptions}
                              />
                              <FieldError name='pairs'/>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'TRADE_FEE' && !!values.feePolicyType && values.feePolicyType.value === "PERCENTAGE" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="percent" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Percent')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="percent"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'TRADE_FEE' && !!values.feePolicyType && values.feePolicyType.value === "NEW_AMOUNT" &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="amount" validate={composeValidators(required, mustBeNumber, mustNotBeNegative)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Amount')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="amount"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'REFERRAL' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="limit" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Percent')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="limit"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'MAX_REFERRAL' &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="limit" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Percent')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="limit"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.effectObject && values.effectObject.value === 'MAX_REFERRAL' &&
                          <Row className="mb-4">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="extendToCurrent" validate={required}>
                                {({input}) => (
                                  <Row className='align-items-center'>
                                    <Switch
                                      className="mx-3 ltr"
                                      onChange={enabled => {input.onChange(enabled);}}
                                      checked={values.extendToCurrent}
                                      height={24}
                                      width={45}
                                    />
                                    <span className="mx-2">{t('Extend To Current')}</span>
                                  </Row>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Bonus Code Expiration condition')}</span>
                            <Field
                              name="expirationConditions"
                              component={this.MultiSelectAdapter}
                              options={this.expirationConditions}
                            />
                            <FieldError name='expirationConditions'/>
                          </Col>
                        </Row>
                        {!!values.expirationConditions && !!find(values.expirationConditions, {value: "TOTAL_VOL"}) &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="volume" validate={composeValidators(required, mustBeNumber, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Bonus Code Limit for Total Volume')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="volume"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.expirationConditions && !!find(values.expirationConditions, {value: "USAGE_TIME"}) &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="interval" validate={composeValidators(required, mustBeNumber, mustBeInteger, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Bonus Code Interval Days')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="interval"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.expirationConditions && !!find(values.expirationConditions, {value: "END_TIME"}) &&
                          <Row className="mb-4">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Bonus Code Expiration Date')}<span className="required">*</span></span>
                              <Field name="expiresAt" validate={required}>
                                {({input}) => (
                                  <MuiPickersUtilsProvider
                                    utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                                    locale={i18n.language}
                                  >
                                    <DateTimePicker
                                      {...getDatePickerProps()}
                                      minDate={moment()}
                                      maxDate={undefined}
                                      value={input.value ? input.value : null}
                                      onChange={date => {
                                        if (moment(date) >= moment()) {
                                          input.onChange(date);
                                        } else {
                                          alert(t("The selected time must be ahead of the current time."));
                                        }
                                      }}
                                      TextFieldComponent={props =>
                                        <Input
                                          style={{width: '100%'}}
                                          placeholder={t('Select')}
                                          {...props}
                                        />
                                      }
                                    />
                                  </MuiPickersUtilsProvider>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        <Row className="mb-3">
                          <Col className="col-lg-5 col-md-12">
                            <span>{t('Bonus Policy Validity condition')}</span>
                            <Field
                              name="validityConditions"
                              component={this.MultiSelectAdapter}
                              options={this.validityConditions}
                            />
                            <FieldError name='validityConditions'/>
                          </Col>
                        </Row>
                        {!!values.validityConditions && !!find(values.validityConditions, {value: "NUMBER_OF_USAGES"}) &&
                          <Row className="mb-3">
                            <Col className="col-lg-5 col-md-12">
                              <Field name="count" validate={composeValidators(required, mustBeNumber, mustBeInteger, mustBePositive)}>
                                {({input}) => (
                                  <div>
                                    <span>{t('Bonus Policy Usages Count')}<span className="required">*</span></span>
                                    <Input
                                      {...input}
                                      value={numberWithCommas(input.value)}
                                      onChange={e => {input.onChange(stringToNumber(e.target.value));}}
                                    />
                                    <FieldError name="count"/>
                                  </div>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        {!!values.validityConditions && !!find(values.validityConditions, {value: "TIMESTAMP"}) &&
                          <Row className="mb-4">
                            <Col className="col-lg-5 col-md-12">
                              <span>{t('Bonus Policy Validity Date')}<span className="required">*</span></span>
                              <Field name="validatedUntil" validate={required}>
                                {({input}) => (
                                  <MuiPickersUtilsProvider
                                    utils={i18n.language === fa_IR ? JalaliUtils : MomentUtils}
                                    locale={i18n.language}
                                  >
                                    <DateTimePicker
                                      {...getDatePickerProps()}
                                      minDate={moment()}
                                      maxDate={undefined}
                                      value={input.value ? input.value : null}
                                      onChange={date => {
                                        if (moment(date) >= moment()) {
                                          input.onChange(date);
                                        } else {
                                          alert(t("The selected time must be ahead of the current time."));
                                        }
                                      }}
                                      TextFieldComponent={props =>
                                        <Input
                                          style={{width: '100%'}}
                                          placeholder={t('Select')}
                                          {...props}
                                        />
                                      }
                                    />
                                  </MuiPickersUtilsProvider>
                                )}
                              </Field>
                            </Col>
                          </Row>
                        }
                        <LoaderButton
                          loading={submitting}
                          onClick={() => {
                            this.openConfirmDialog(
                              handleSubmit,
                            );
                          }}
                          disabled={pristine || hasValidationErrors || submitting}
                          className="mt-4 text-center"
                          style={{minWidth: '100px'}}>
                          {t('Submit')}
                        </LoaderButton>
                      </Form>
                    );
                  }}
                />
              </CardBody>
            </Card>
          </Colxx>
        </Row>
      </Fragment>
    );
  }
}

export default withTranslation()(Create);
